import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ChangeDetectionStrategy,Input, Inject } from '@angular/core';


@Component({
  selector: 'app-modal-erro-mensagem',
  templateUrl: './modal-erro-mensagem.component.html',
  styleUrls: ['./modal-erro-mensagem.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalErroMensagemComponent implements OnInit {

  MensagemErro: string;
  MensagemErroCor: string = "Vermelho";

  TituloErro: string = "Falha"

  AlinhamentoBotao: string = "Esquerda";

  BotaoCor: string = "warn"
  BotaoMesagem: string = "Cancelar"

  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.MensagemErro = data.mensagem
    
    if(data.TituloErro){
      this.TituloErro = data.TituloErro
    }

    if(data.AlinhamentoBotao) {
      this.AlinhamentoBotao = data.AlinhamentoBotao
    }

    if(data.MensagemErroCor) {
      this.MensagemErroCor = data.MensagemErroCor
    }

    if(data.BotaoCor) {
      this.BotaoCor = data.BotaoCor
    }

    if(data.BotaoMesagem) {
      this.BotaoMesagem = data.BotaoMesagem
    }

   }

  ngOnInit(): void {

  }
}
